import { useState } from "react";

export default function useDateFilter() {
    const [date, setDate] = useState({
        from: '',
        to: ''
    });

    const handleQuickSelect = (type: string) => {

        const formatDate = (d: Date, isEndTime = false) => {
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');

            const time = isEndTime ? "23:59:59" : "00:00:00";
            return `${year}-${month}-${day} ${time}`;
        };

        let start = new Date();
        let end = new Date();
        const now = new Date();

        if (type === 'all_time') {
            setDate({ from: '', to: '' });
            return;
        }


        if (type === 'today') {
            start = new Date();
            end = new Date();
        } else if (type === 'yesterday') {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            start = yesterday;
            end = yesterday;
        } else if (type === 'current_month') {
            start = new Date(now.getFullYear(), now.getMonth(), 1);
            end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        } else if (type === 'last_month') {
            start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            end = new Date(now.getFullYear(), now.getMonth(), 0);
        }

        setDate({
            from: formatDate(start, false),
            to: formatDate(end, true)
        });
    };


    // useEffect(() => {
    //     if (!date.from || !date.to) {
    //         const now = new Date();
    //         const year = now.getFullYear();
    //         const month = String(now.getMonth() + 1).padStart(2, '0');
    //         const day = String(now.getDate()).padStart(2, '0');

    //         setDate(prev => ({
    //             from: prev.from || `${year}-${month}-${day} 00:00:00`,
    //             to: prev.to || `${year}-${month}-${day} 23:59:59`,
    //         }));
    //     }
    // }, []);


    return {
        date,
        setDate,
        handleQuickSelect
    };
}